DJ.addBehavior('js-astuces', '.js-astuces', {
  attach: function (context, settings, behavior) {
    var holder = jQuery(context);
    var slider = holder.find('.slider');
    var controls = holder.find('.slider-controls')
    slider.slick({
      adaptiveHeight: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      dots: true,
      appendDots: controls.find('.slide-dots'),
      prevArrow: controls.find('.slide-prev'),
      nextArrow: controls.find('.slide-next')
    });
  },

  detach: function (context, settings) { }
});
